export default "__VITE_ASSET__DPkRKklf__"